
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class SettingsFormItem extends Vue {
  @Prop({ required: true }) label: string

  created() {}

  mounted() {}

  updated() {}

  destroyed() {}
}
